let currentHash = {
  totalTime: 0,
  scrolledToBottom: false,
  maxScrolledPercentage: 0,
  calculatorOptionsClick: {},
  calculatorAtLeastOneOptionClick: false,
  questionsCarrotsClick: {},
  questionsCarrotsAtLeastOneClick: false,
  cancelExitExercise: false
};

const statInitialData = (init = {}) => {
  currentHash = {
    ...currentHash,
    ...{ initDate: Date.now() },
    ...init
  };
};

const handleStatPageScroll = (contentEl) => {
  const contentElBox = contentEl.getBoundingClientRect();

  const scrolledHeight = contentEl.scrollHeight - contentEl.scrollTop;
  const maxViewHeight = contentElBox.height;
  const maxScrollHeight = contentEl.scrollHeight - contentElBox.height;

  const reachedBottom = (maxScrollHeight > 1) && Math.abs(scrolledHeight - maxViewHeight) <= 1;
  const scrolledPercentage = (
    maxScrollHeight > 0 ? Math.round(contentEl.scrollTop * 100 / maxScrollHeight) : 0
  );

  if (!currentHash.scrolledToBottom) {
    currentHash.scrolledToBottom = reachedBottom;
  }

  const calculatedPercentage = reachedBottom ? 100 : scrolledPercentage;
  if (calculatedPercentage > currentHash.maxScrolledPercentage) {
    currentHash.maxScrolledPercentage = calculatedPercentage;
  }
};

const handleStatCalculatorOptionClick = (option) => {
  currentHash.calculatorOptionsClick[option.id] = true;
  if (!currentHash.calculatorAtLeastOneOptionClick) {
    currentHash.calculatorAtLeastOneOptionClick = true;
  }
};

const handleStatQuestionCarrotClick = (option) => {
  currentHash.questionsCarrotsClick[option.id] = true;
  if (!currentHash.questionsCarrotsAtLeastOneClick) {
    currentHash.questionsCarrotsAtLeastOneClick = true;
  }
};

const handleStatCancelExitClick = () => {
  currentHash.cancelExitExercise = true;
};

const statSendData = (customData = {}) => {
  const postData = {
    kind: 'completeSurvey',
    result: {
      ...currentHash,
      ...customData,
      ...{ totalTime: Math.round((Date.now() - currentHash.initDate) / 1000) }
    }
  };

  (window.parent || window).postMessage(postData, "*");
};

export {
  statInitialData, statSendData,
  handleStatPageScroll, handleStatCalculatorOptionClick, handleStatQuestionCarrotClick,
  handleStatCancelExitClick
};
